import React, { useEffect, useState } from 'react';
import { WidgetProps } from '@rjsf/utils';
import { MenuItem, TextField } from '@mui/material';
import { DetailRow } from '../../../DetailsDrawer/DetailRow';

export const MultiSelectInput = (props: WidgetProps) => {
  const { options, required, value, onChange, schema } = props;
  const [selectedValues, setSelectedValues] = useState<string[]>(Array.isArray(value) ? value : []);

  // RJSF only populates enumOptions for top-level enum; for array+items.enum schemas,
  // fall back to reading from schema.items.enum directly
  const itemsEnum = (schema?.items as { enum?: unknown[] } | undefined)?.enum;
  const optionsList: string[] =
    options?.enumOptions && options.enumOptions.length > 0
      ? options.enumOptions
          .filter((opt: { label?: string; value: string }) => opt.value !== null)
          .map((opt: { label?: string; value: string }) => opt.label || opt.value)
      : ((itemsEnum as string[] | undefined) || []).filter(Boolean);

  const label = props.uiSchema?.['ui:placeholder'] as string | undefined;

  useEffect(() => {
    setSelectedValues(Array.isArray(value) ? value : []);
  }, [value]);

  if (props.readonly) {
    const displayValue = Array.isArray(value) ? value.join(', ') : value;
    if (props.formContext?.hideEmpty && !displayValue) return null;
    return (
      <div>
        <DetailRow
          key={props.id}
          colId={props.id}
          title={label || ''}
          value={displayValue}
        />
      </div>
    );
  }

  return (
    <TextField
      select
      required={required}
      sx={{ width: '100%' }}
      label={label}
      size="small"
      value={selectedValues}
      SelectProps={{
        multiple: true,
        renderValue: (selected) => (selected as string[]).join(', '),
        MenuProps: { PaperProps: { style: { maxHeight: 200 } } }
      }}
      onChange={(e) => {
        const newValues = e.target.value as unknown as string[];
        setSelectedValues(newValues);
        onChange(newValues.length > 0 ? newValues : undefined);
      }}>
      {optionsList.map((option) => (
        <MenuItem
          key={option}
          value={option}
          style={{ fontSize: '.875rem' }}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default MultiSelectInput;
